import { Field, Form, Formik } from "formik";
import {  useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signUp } from "../../services";
import * as Yup from "yup";
import { images } from "../../assets/images";
import { Oval } from "react-loader-spinner";

export const Register = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const initialValues = {
        name: '',
        surname: '',
        website: '',
        email: '',
        password: '',
    }
    const handleSubmit = values => {
        setIsLoading(true);
        signUp(values.name, values.surname, values.website, values.email, values.password)
            .then(resp => {
            setIsLoading(false);
                const returnToUrl = new URLSearchParams(location.search).get("returnUrl");
                navigate(returnToUrl || `/login`);
            }).catch(err => {
                const data = err.response.data.message;
                setErrorMessage(data);
            })
    }
    const RegisterSchema = Yup.object().shape({
        name: Yup.string().required("Enter your name"),
        surname: Yup.string().required("Enter your surname"),
        website: Yup.string().required("Enter your website"),
        email: Yup.string().email().required("Enter your email"),
        password: Yup.string().required("Enter your password"),
    })
    return (
        <main className="has-black-bg has-full-height">
            <header className="w-[95%] m-auto pt-12">
                <a href="https://skinsagency.com">
                    <img src={images.logo} alt="logo" />
                </a>
            </header>
            <article className="flex flex-col justify-self-center justify-between items-start gap-5 pt-20">
                <h1 className="text-8xl text-light-grey font-light">Register</h1>
                {errorMessage !== "" ? (
                    <p className="text-sm has-yellow-text">
                        {errorMessage}
                    </p>
                ) : (
                    <></>
                )}
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values) => handleSubmit(values)}
                    autoComplete="off"
                    validationSchema={RegisterSchema}
                >
                    {({ errors, touched }) => (
                        <Form
                            method="POST"
                            autoComplete="off"
                            className="flex flex-col gap-4"
                        >
                            <Field
                                name="name"
                                type="text"
                                className={(errors.name && touched.name) ? "has-border-bottom-error" : "has-border-bottom"}
                                placeholder="Name"
                                autoComplete="off" />
                            <Field
                                name="surname"
                                type="text"
                                className={(errors.surname && touched.surname) ? "has-border-bottom-error" : "has-border-bottom"}
                                placeholder="Surname"
                                autoComplete="off" />
                            <Field
                                name="website"
                                type="text"
                                className={(errors.website && touched.website) ? "has-border-bottom-error" : "has-border-bottom"}
                                placeholder="Website"
                                autoComplete="off" />
                            <Field
                                name="email"
                                type="email"
                                className={(errors.email && touched.email) ? "has-border-bottom-error" : "has-border-bottom"}
                                placeholder="Email"
                                autoComplete="off" />
                            <Field
                                name="password"
                                type="password"
                                className={(errors.password && touched.password) ? "has-border-bottom-error" : "has-border-bottom"}
                                placeholder="Password"
                                autoComplete="off" />
                            {/* <fieldset className="flex flex-col gap-2">
                                        <Field
                                            name="confirmPassword"
                                            type="text"
                                            className="has-border-bottom"
                                            placeholder="Confirm your password"
                                            autoComplete="off" />
                                        {errors.confirmPassword && touched.confirmPassword ? (
                                            <p className="required has-red-text">{errors.confirmPassword}</p>
                                        ) : null}
                                    </fieldset> */}
                            { }
                            <div className="terms__container">
                                <input type="checkbox" value="terms" />
                                <label htmlFor="terms"> I have read and accept <a target="_blank" rel="noreferrer" href="https://skinsagency.com/terms-and-conditions" style={{ textDecoration: "underline" }}>terms and conditions</a> and <a target="_blank" rel="noreferrer" href="https://skinsagency.com/privacy-policy" style={{ textDecoration: "underline" }}>privacy policy</a>.</label>
                            </div>
                            <button className="flex fle-col items-center justify-center bg-brand-yellow p-5 text-xl rounded-[4px] text-black" type="submit">
                                {isLoading ? (
                                    <Oval 
                                    height={30}
                                    width={50}
                                    color="black"
                                    secondaryColor="black"
                                    />
                                ): (
                                    <span>
                                        Sign Up
                                    </span>
                                )}
                            </button>
                            <a href="/login">
                                Have an account? <span className="text-brand-yellow">Log in.</span>
                            </a>
                        </Form>
                    )}
                </Formik>
            </article>
        </main>
    )
}